import { css } from '@emotion/core';
export var sideboxFrame = {
  name: "164r41r",
  styles: "margin-top:8px;"
};
export var sideboxRef = {
  name: "dy158c",
  styles: "position:relative;top:-16px;"
};